





























































import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import Place from '@/dto/deliveries/Place'
import LocationService from '@/services/LocationService'
import Country from '@/dto/deliveries/Country'
import PlaceSelectOption from '@/components/calculator/CalculatorForm/PlaceSelect/PlaceSelectOption.vue'
import PlaceSelectEmptyResult from '@/components/calculator/CalculatorForm/PlaceSelect/PlaceSelectEmptyResult.vue'
import PlaceSelectSearchHint from '@/components/calculator/CalculatorForm/PlaceSelect/PlaceSelectSearchHint.vue'
import CalculateStore from '@/stores/CalculateStore'

@Component({
  inheritAttrs: false,
  components: {
    PlaceSelectSearchHint,
    PlaceSelectEmptyResult,
    PlaceSelectOption,
  },
})
export default class PlaceSelect extends Vue {
  @Prop(Object) country: Country
  @Ref('placeSelect') placeSelect: HTMLInputElement

  query = ''

  options: readonly Place[] = Object.freeze([])

  get place(): Place | null {
    return CalculateStore.place
  }

  set place(place: Place | null) {
    if (place) {
      CalculateStore.setPlace(place)
    }
  }

  get preparedQuery(): string {
    return this.query.trim().toLowerCase()
  }

  getDisplayValue(place?: Place): string {
    return place
      ? [place.name, place.region].filter(value => !!value).join(', ')
      : ''
  }

  onFocus() {
    const input = this.placeSelect.querySelector(
      'input[type="search"]'
    ) as HTMLInputElement

    if (input) {
      input.select()
    }
  }

  filterFn(val: string, update: Function, abort: Function) {
    this.query = val.trim().toLowerCase()

    if (val.length < 1) {
      abort()
      return
    }

    if (val.length < 3) {
      update(() => (this.options = []))
      return
    }

    LocationService.searchPlaces(this.country.id, this.query).then(places =>
      update(() => (this.options = Object.freeze(places)))
    )
  }
}
